import { render } from "./Competences.vue?vue&type=template&id=00f27a5a"
import script from "./Competences.vue?vue&type=script&lang=js"
export * from "./Competences.vue?vue&type=script&lang=js"

import "./Competences.vue?vue&type=style&index=0&id=00f27a5a&lang=scss"

import exportComponent from "/builds/smartcom-gitlab-cis/maap/Application/Frontends/ProSpace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__